import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataModelService } from '../../../../../services/datamodel.service';

@Component({
    selector: 'update-mapping',
    templateUrl: 'update.mapping.html',
    styleUrls: ['update.mapping.css']
})
export class UpdateMappingForm {

    //#region SelectedItem
    SelectedItemValue;
    @Input()
    get SelectedItem() {
        return this.SelectedItemValue;
    }
    set SelectedItem(val) {
        this.SelectedItemValue = val;
        this.SelectedItemChange.emit(this.SelectedItemValue);
    }

    @Output() SelectedItemChange = new EventEmitter<any>();
    //#endregion

    //#region Fields
    FieldsValue;
    @Input()
    get Fields() {
        return this.FieldsValue;
    }
    set Fields(val) {
        this.FieldsValue = val;
        this.FieldsChange.emit(this.FieldsValue);
    }

    @Output() FieldsChange = new EventEmitter<any>();
    //#endregion

    @Output() ValuesChanged = new EventEmitter<any>();

    constructor(private _translate: TranslateService, private _dataModelService: DataModelService) {
    }
    ItemValuesChanged() {
        this.ValuesChanged.emit();
    }
}